module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAANJJREFUWEft1sENAiEQhWFowh70oBcCtKSW42VtRs9L4KD1QDAk7p2ZeYTLbgH8X2aTyWg1+dOT+2oHkCZgrb2EED7I39YNMMbca60PpdQtpbSgEN0A59yplPKqtR601tcY4xOB6Aa02AgECTACQQagESwAEsEGoBAiAAIhBkgREEBDeO+POec3dU/AANxJQAGcKcAAnHibGgTAjUMAkrgYII2LAIg4G4CKswDIOBmAjpMAI64hEmA7SpH3IAnw3/XndV2/iGN0ewOyCSWgHTB9Aj+RUvQhJ0EpswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-wuxijimore@2x.png
// module id = 122
// module chunks = 0